import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AdminPanelService } from 'app/services/admin-panel.service';
import { AuthService } from 'app/services/auth/auth.service';
import { CompanyService } from 'app/services/company/company.service';
import { Company } from 'app/services/company/company.model';

@Component({
  selector: 'app-admin-panel',
  templateUrl: './admin-panel.component.html',
  styleUrls: ['./admin-panel.component.css']
})
export class AdminPanelComponent implements OnInit {

  currentTaskInQueue = 0;

  refreshInterval: any;

  loading = false;

  billingYear = new Date().getFullYear();
  billingQuarter = 1;

  reloadFileHash = '';

  availableCompanies: Company[] = [];
  selectedReactivateCompany: Company;

  resendActivationEmailUname = '';
  resendActivationEmailEmail = '';

  driverLookupDriverId = '';
  driverLookupCardNumber = '';
  driverCompaniesResult = '';
  driverCompaniesError = '';

  vehicleLookupVehicleId = '';
  vehicleLookupVin = '';
  vehicleCompaniesResult = '';
  vehicleCompaniesError = '';

  deviceLookupImei = '';
  deviceInfosResult = '';
  deviceInfosError = '';

  constructor(
    private readonly adminPanelService: AdminPanelService,
    private readonly authService: AuthService,
    private readonly translate: TranslateService,
    private readonly companyService: CompanyService
  ) { }

  ngOnInit(): void {
    this.refreshStat();
    this.refreshInterval = setInterval(() => {
      this.refreshStat();
    }, 10000);
    this.loadCompanies();
  }

  loadCompanies(): void {
    this.companyService.getAllSubcompanies().subscribe((companies) => {
      this.availableCompanies = [...companies].sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.refreshInterval);
  }

  refreshStat() {
    this.adminPanelService.generateInfringementsForCompanyAndAllSubCompaniesStat()
      .subscribe((response) => {
        this.currentTaskInQueue = response.queueSize;
      });
  }

  cancelRegenerateInfringements() {
    this.adminPanelService.generateInfringementsForCompanyAndAllSubCompaniesCancel()
      .subscribe(() => {
        this.refreshStat();
      })
  }

  regenerateInfringements() {
    this.loading = true;
    const companyId = this.authService.currentCompanyIdValue();
    this.adminPanelService.generateInfringementsForCompanyAndAllSubCompanies(
      companyId
    ).subscribe(() => {
      this.refreshStat();
      this.loading = false;
    })
  }

  calculateBilling() {
    this.adminPanelService.calculateBills(this.billingYear, this.billingQuarter).subscribe(() => {
      // this.billingYear = new Date().getFullYear();
      // this.billingQuarter= 1;
    });
  }

  reloadDataForFile() {
    this.adminPanelService.reloadDataForFile(this.reloadFileHash).subscribe(() => {
      this.reloadFileHash = '';
    });
  }

  reactivateNotPayingClient() {
    if (!this.selectedReactivateCompany) {
      return;
    }
    this.adminPanelService.reactivateNotPayingClient('' + this.selectedReactivateCompany.id).subscribe(() => {
      this.selectedReactivateCompany = undefined;
    });
  }

  resendActivationEmail() {
    this.adminPanelService.resendActivationEmail(this.resendActivationEmailUname, this.resendActivationEmailEmail).subscribe(() => {
      this.resendActivationEmailUname = '';
      this.resendActivationEmailEmail = '';
    });
  }

  canQueryDriverCompanies() {
    return !!this.driverLookupDriverId?.trim() || !!this.driverLookupCardNumber?.trim();
  }

  canQueryVehicleCompanies() {
    return !!this.vehicleLookupVehicleId?.trim() || !!this.vehicleLookupVin?.trim();
  }

  queryDriverCompanies() {
    this.driverCompaniesResult = '';
    this.driverCompaniesError = '';
    if (!this.canQueryDriverCompanies()) {
      this.driverCompaniesError = this.translate.instant('AdminPanel.DriverOrCardRequired');
      return;
    }

    this.adminPanelService.getDriverCompanyNames(
      this.driverLookupDriverId?.trim() || undefined,
      this.driverLookupCardNumber?.trim() || undefined
    ).subscribe((response) => {
      this.driverCompaniesResult = response.companies || '';
      this.driverCompaniesError = response.error || '';
    }, () => {
      this.driverCompaniesError = this.translate.instant('AdminPanel.FailedToFetchDriverCompanies');
    });
  }

  queryVehicleCompanies() {
    this.vehicleCompaniesResult = '';
    this.vehicleCompaniesError = '';
    if (!this.canQueryVehicleCompanies()) {
      this.vehicleCompaniesError = this.translate.instant('AdminPanel.VehicleOrVinRequired');
      return;
    }

    this.adminPanelService.getVehicleCompanyNames(
      this.vehicleLookupVehicleId?.trim() || undefined,
      this.vehicleLookupVin?.trim() || undefined
    ).subscribe((response) => {
      this.vehicleCompaniesResult = response.companies || '';
      this.vehicleCompaniesError = response.error || '';
    }, () => {
      this.vehicleCompaniesError = this.translate.instant('AdminPanel.FailedToFetchVehicleCompanies');
    });
  }

  canQueryDeviceInfos() {
    return !!this.deviceLookupImei?.trim();
  }

  queryDeviceInfos() {
    this.deviceInfosResult = '';
    this.deviceInfosError = '';
    if (!this.canQueryDeviceInfos()) {
      this.deviceInfosError = this.translate.instant('AdminPanel.ImeiRequired');
      return;
    }

    this.adminPanelService.getDeviceInfos(
      this.deviceLookupImei.trim()
    ).subscribe((response) => {
      this.deviceInfosResult = response.device || '';
      this.deviceInfosError = response.error || '';
    }, () => {
      this.deviceInfosError = this.translate.instant('AdminPanel.FailedToFetchDeviceInfos');
    });
  }


}
